import React from 'react';
import { NavLink, useRouteMatch } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useRegionalLink } from 'hooks/useRegionalLink';

import { Company } from 'components/common/Elements/Elements';

const Account = ({ data }) => {
  let { url } = useRouteMatch();
  const generateRegionalPath = useRegionalLink();
  const {
    customerId,
    companyName,
    status,
    companySize,
    country,
    website,
    customerType
  } = data;

  return (
    <NavLink to={generateRegionalPath(`${url}/${customerId}/general`)}>
      <Company
        nameCompany={companyName ? companyName : customerId}
        status={status}
        description={companySize}
        recordType={customerType}
        country={country}
        domain={website}
        customerId={customerId}
      />
    </NavLink>
  );
};

Account.propTypes = {
  data: PropTypes.shape({
    customerId: PropTypes.string,
    companyName: PropTypes.string,
    country: PropTypes.string,
    status: PropTypes.string,
    companySize: PropTypes.string,
    website: PropTypes.string,
    customerType: PropTypes.string
  })
};

export default Account;
